import TagManager from "react-gtm-module";

function DeleteSchoolConfirmCP({ ipeds }) {
  const tagManagerArgs = {
    dataLayer: {
      event: "interactionEvent",
      eventName: "delete_school_confirm",
      ipeds: ipeds,
    },
  };

  TagManager.dataLayer(tagManagerArgs);
}

export default DeleteSchoolConfirmCP;
